import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "statistic-container" }
const _hoisted_2 = { class: "stat-card" }
const _hoisted_3 = { class: "card-body" }
const _hoisted_4 = { class: "stat-grid" }
const _hoisted_5 = { class: "stat-item" }
const _hoisted_6 = { class: "stat-value" }
const _hoisted_7 = { class: "stat-item" }
const _hoisted_8 = { class: "stat-value" }
const _hoisted_9 = { class: "stat-item" }
const _hoisted_10 = { class: "stat-value" }
const _hoisted_11 = { class: "stat-item" }
const _hoisted_12 = { class: "stat-value" }
const _hoisted_13 = { class: "stat-item" }
const _hoisted_14 = { class: "stat-value" }
const _hoisted_15 = { class: "stat-item" }
const _hoisted_16 = { class: "stat-value" }
const _hoisted_17 = { class: "stat-item" }
const _hoisted_18 = { class: "stat-value" }
const _hoisted_19 = { class: "stat-item" }
const _hoisted_20 = { class: "stat-value" }
const _hoisted_21 = { class: "stat-item" }
const _hoisted_22 = { class: "stat-value" }
const _hoisted_23 = { class: "stat-item" }
const _hoisted_24 = { class: "stat-value" }
const _hoisted_25 = { class: "stat-item" }
const _hoisted_26 = { class: "stat-value" }
const _hoisted_27 = { class: "stat-item" }
const _hoisted_28 = { class: "stat-value" }
const _hoisted_29 = {
  key: 0,
  class: "summary-section"
}
const _hoisted_30 = { class: "summary-items" }
const _hoisted_31 = { class: "summary-item" }
const _hoisted_32 = { class: "summary-value" }
const _hoisted_33 = { class: "summary-item" }
const _hoisted_34 = { class: "summary-value" }
const _hoisted_35 = { class: "summary-item" }
const _hoisted_36 = { class: "summary-value" }
const _hoisted_37 = { class: "summary-item" }
const _hoisted_38 = { class: "summary-value" }
const _hoisted_39 = { class: "stat-card" }
const _hoisted_40 = { class: "card-body" }
const _hoisted_41 = { class: "stat-grid" }
const _hoisted_42 = { class: "stat-item" }
const _hoisted_43 = { class: "stat-value" }
const _hoisted_44 = { class: "stat-item" }
const _hoisted_45 = { class: "stat-value" }
const _hoisted_46 = { class: "stat-item" }
const _hoisted_47 = { class: "stat-value" }
const _hoisted_48 = { class: "stat-item" }
const _hoisted_49 = { class: "stat-value" }
const _hoisted_50 = { class: "stat-item" }
const _hoisted_51 = { class: "stat-value" }
const _hoisted_52 = { class: "stat-item" }
const _hoisted_53 = { class: "stat-value" }
const _hoisted_54 = { class: "stat-item" }
const _hoisted_55 = { class: "stat-value" }
const _hoisted_56 = { class: "stat-item" }
const _hoisted_57 = { class: "stat-value" }
const _hoisted_58 = { class: "stat-item" }
const _hoisted_59 = { class: "stat-value" }
const _hoisted_60 = { class: "stat-item" }
const _hoisted_61 = { class: "stat-value" }
const _hoisted_62 = { class: "stat-item" }
const _hoisted_63 = { class: "stat-value" }
const _hoisted_64 = { class: "stat-item" }
const _hoisted_65 = { class: "stat-value" }
const _hoisted_66 = {
  key: 0,
  class: "summary-section"
}
const _hoisted_67 = { class: "summary-items" }
const _hoisted_68 = { class: "summary-item" }
const _hoisted_69 = { class: "summary-value" }
const _hoisted_70 = { class: "summary-item" }
const _hoisted_71 = { class: "summary-value" }
const _hoisted_72 = { class: "summary-item" }
const _hoisted_73 = { class: "summary-value" }
const _hoisted_74 = { class: "summary-item" }
const _hoisted_75 = { class: "summary-value" }
const _hoisted_76 = { class: "stat-card" }
const _hoisted_77 = { class: "card-body" }
const _hoisted_78 = { class: "stat-grid" }
const _hoisted_79 = { class: "stat-item" }
const _hoisted_80 = { class: "stat-value" }
const _hoisted_81 = { class: "stat-item" }
const _hoisted_82 = { class: "stat-value" }
const _hoisted_83 = { class: "stat-item" }
const _hoisted_84 = { class: "stat-value" }
const _hoisted_85 = { class: "stat-item" }
const _hoisted_86 = { class: "stat-value" }
const _hoisted_87 = { class: "stat-item" }
const _hoisted_88 = { class: "stat-value" }
const _hoisted_89 = { class: "stat-item" }
const _hoisted_90 = { class: "stat-value" }
const _hoisted_91 = { class: "stat-item" }
const _hoisted_92 = { class: "stat-value" }
const _hoisted_93 = { class: "stat-item" }
const _hoisted_94 = { class: "stat-value" }
const _hoisted_95 = { class: "stat-item" }
const _hoisted_96 = { class: "stat-value" }
const _hoisted_97 = { class: "stat-item" }
const _hoisted_98 = { class: "stat-value" }
const _hoisted_99 = { class: "stat-item" }
const _hoisted_100 = { class: "stat-value" }
const _hoisted_101 = { class: "stat-item" }
const _hoisted_102 = { class: "stat-value" }
const _hoisted_103 = {
  key: 0,
  class: "summary-section"
}
const _hoisted_104 = { class: "summary-items" }
const _hoisted_105 = { class: "summary-item" }
const _hoisted_106 = { class: "summary-value" }
const _hoisted_107 = { class: "summary-item" }
const _hoisted_108 = { class: "summary-value" }
const _hoisted_109 = { class: "summary-item" }
const _hoisted_110 = { class: "summary-value" }
const _hoisted_111 = { class: "summary-item" }
const _hoisted_112 = { class: "summary-value" }

import {computed} from 'vue';

// 定义数据类型
interface StatisticResult {
  totalAdd: number,
  totalSef: number,
  totalCal: number,
  monthAdd: number,
  monthSef: number,
  motnCal: number,
  dayAdd: number,
  daySef: number,
  dayCal: number,

  htotalAdd: number,
  htotalSef: number,
  htotalCal: number,
  hmonthAdd: number,
  hmonthSef: number,
  hmotnCal: number,
  hdayAdd: number,
  hdaySef: number,
  hdayCal: number,

  htotalCalLV: number,
  monthAddNotHt: number,
  totalCalNotHt: number,
  dayAddNotHt: number,
  daySefNotHt: number,
  monthSefNotHt: number,
  totalSefNotHt: number,
  dayCalNotHt: number,
  totalAddNotHt: number,
  motnCalNotHt: number,
}

interface GroupedItem {
  totalAdd: number;
  totalSef: number;
  totalCal: number;
  monthAdd: number;
  monthSef: number;
  monthCal: number;
  dayAdd: number;
  daySef: number;
  dayCal: number;
}

interface SummaryData {
  baoFuAdd: number;
  baoFuCal: number;
  baoFuSelf: number;
  bBaoFuAdd: number;
  bBaoFuCal: number;
  bBaoFuSelf: number;
  huiFuAdd: number;
  huiFuSelf: number;
  huiFuCal: number;
}

// 定义 Props 接收父组件传来的数据

export default /*@__PURE__*/_defineComponent({
  __name: 'tb_content',
  props: {
    groupedData: {},
    summaryData: {},
    hasDateFilter: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

// 汇付数据（前缀 h 开头）
const huiFuData = computed<GroupedItem>(() => {
  const data = props.groupedData || {};
  return {
    totalAdd: data.htotalAdd || 0,
    totalSef: data.htotalSef || 0,
    totalCal: data.htotalCal || 0,
    monthAdd: data.hmonthAdd || 0,
    monthSef: data.hmonthSef || 0,
    monthCal: data.hmotnCal || 0,
    dayAdd: data.hdayAdd || 0,
    daySef: data.hdaySef || 0,
    dayCal: data.hdayCal || 0
  };
});

// 宝付数据灏天（无前缀）
const baoFuData = computed<GroupedItem>(() => {
  const data = props.groupedData || {};
  return {
    totalAdd: data.totalAdd || 0,
    totalSef: data.totalSef || 0,
    totalCal: data.totalCal || 0,
    monthAdd: data.monthAdd || 0,
    monthSef: data.monthSef || 0,
    monthCal: data.motnCal || 0,
    dayAdd: data.dayAdd || 0,
    daySef: data.daySef || 0,
    dayCal: data.dayCal || 0
  };
});

// 宝付数据邦远（无前缀）
const bBaoFuData = computed<GroupedItem>(() => {
  const data = props.groupedData || {};
  return {
    totalAdd: data.totalAddNotHt || 0,
    totalSef: data.totalSefNotHt || 0,
    totalCal: data.totalCalNotHt || 0,
    monthAdd: data.monthAddNotHt|| 0,
    monthSef: data.monthSefNotHt || 0,
    monthCal: data.motnCalNotHt || 0,
    dayAdd: data.dayAddNotHt || 0,
    daySef: data.daySefNotHt || 0,
    dayCal: data.dayCalNotHt || 0
  };
});

// 计算退订率
const calculateRate = (cal: number, add: number): string => {
  if (add === 0) return '0.00';
  return ((cal / add) * 100).toFixed(2);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[17] || (_cache[17] = _createElementVNode("div", { class: "card-header" }, [
        _createElementVNode("span", { class: "card-title" }, "宝付数据-灏天")
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _cache[0] || (_cache[0] = _createElementVNode("span", { class: "stat-label" }, "总订购数", -1)),
            _createElementVNode("span", _hoisted_6, _toDisplayString(baoFuData.value.totalAdd), 1)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _cache[1] || (_cache[1] = _createElementVNode("span", { class: "stat-label" }, "自发展订购数", -1)),
            _createElementVNode("span", _hoisted_8, _toDisplayString(baoFuData.value.totalSef), 1)
          ]),
          _createElementVNode("div", _hoisted_9, [
            _cache[2] || (_cache[2] = _createElementVNode("span", { class: "stat-label" }, "总退订数", -1)),
            _createElementVNode("span", _hoisted_10, _toDisplayString(baoFuData.value.totalCal), 1)
          ]),
          _createElementVNode("div", _hoisted_11, [
            _cache[3] || (_cache[3] = _createElementVNode("span", { class: "stat-label" }, "总退订率", -1)),
            _createElementVNode("span", _hoisted_12, _toDisplayString(calculateRate(baoFuData.value.totalCal, baoFuData.value.totalAdd)) + "%", 1)
          ]),
          _createElementVNode("div", _hoisted_13, [
            _cache[4] || (_cache[4] = _createElementVNode("span", { class: "stat-label" }, "月订购数", -1)),
            _createElementVNode("span", _hoisted_14, _toDisplayString(baoFuData.value.monthAdd), 1)
          ]),
          _createElementVNode("div", _hoisted_15, [
            _cache[5] || (_cache[5] = _createElementVNode("span", { class: "stat-label" }, "自发展订购数", -1)),
            _createElementVNode("span", _hoisted_16, _toDisplayString(baoFuData.value.monthSef), 1)
          ]),
          _createElementVNode("div", _hoisted_17, [
            _cache[6] || (_cache[6] = _createElementVNode("span", { class: "stat-label" }, "月退订数", -1)),
            _createElementVNode("span", _hoisted_18, _toDisplayString(baoFuData.value.monthCal), 1)
          ]),
          _createElementVNode("div", _hoisted_19, [
            _cache[7] || (_cache[7] = _createElementVNode("span", { class: "stat-label" }, "月退订率", -1)),
            _createElementVNode("span", _hoisted_20, _toDisplayString(calculateRate(baoFuData.value.monthCal, baoFuData.value.monthAdd)) + "%", 1)
          ]),
          _createElementVNode("div", _hoisted_21, [
            _cache[8] || (_cache[8] = _createElementVNode("span", { class: "stat-label" }, "日订购数", -1)),
            _createElementVNode("span", _hoisted_22, _toDisplayString(baoFuData.value.dayAdd), 1)
          ]),
          _createElementVNode("div", _hoisted_23, [
            _cache[9] || (_cache[9] = _createElementVNode("span", { class: "stat-label" }, "自发展订购数", -1)),
            _createElementVNode("span", _hoisted_24, _toDisplayString(baoFuData.value.daySef), 1)
          ]),
          _createElementVNode("div", _hoisted_25, [
            _cache[10] || (_cache[10] = _createElementVNode("span", { class: "stat-label" }, "日退订数", -1)),
            _createElementVNode("span", _hoisted_26, _toDisplayString(baoFuData.value.dayCal), 1)
          ]),
          _createElementVNode("div", _hoisted_27, [
            _cache[11] || (_cache[11] = _createElementVNode("span", { class: "stat-label" }, "日退订率", -1)),
            _createElementVNode("span", _hoisted_28, _toDisplayString(calculateRate(baoFuData.value.dayCal, baoFuData.value.dayAdd)) + "%", 1)
          ])
        ]),
        (__props.hasDateFilter)
          ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
              _cache[16] || (_cache[16] = _createElementVNode("div", { class: "summary-title" }, "查询汇总（按时间筛选）", -1)),
              _createElementVNode("div", _hoisted_30, [
                _createElementVNode("div", _hoisted_31, [
                  _cache[12] || (_cache[12] = _createElementVNode("span", { class: "summary-label" }, "订购数", -1)),
                  _createElementVNode("span", _hoisted_32, _toDisplayString(__props.summaryData.baoFuAdd), 1)
                ]),
                _createElementVNode("div", _hoisted_33, [
                  _cache[13] || (_cache[13] = _createElementVNode("span", { class: "summary-label" }, "自发展订购数", -1)),
                  _createElementVNode("span", _hoisted_34, _toDisplayString(__props.summaryData.baoFuSelf), 1)
                ]),
                _createElementVNode("div", _hoisted_35, [
                  _cache[14] || (_cache[14] = _createElementVNode("span", { class: "summary-label" }, "退订数", -1)),
                  _createElementVNode("span", _hoisted_36, _toDisplayString(__props.summaryData.baoFuCal), 1)
                ]),
                _createElementVNode("div", _hoisted_37, [
                  _cache[15] || (_cache[15] = _createElementVNode("span", { class: "summary-label" }, "退订率", -1)),
                  _createElementVNode("span", _hoisted_38, _toDisplayString(calculateRate(__props.summaryData.baoFuCal, __props.summaryData.baoFuAdd)) + "%", 1)
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_39, [
      _cache[35] || (_cache[35] = _createElementVNode("div", { class: "card-header" }, [
        _createElementVNode("span", { class: "card-title" }, "宝付数据-邦远")
      ], -1)),
      _createElementVNode("div", _hoisted_40, [
        _createElementVNode("div", _hoisted_41, [
          _createElementVNode("div", _hoisted_42, [
            _cache[18] || (_cache[18] = _createElementVNode("span", { class: "stat-label" }, "总订购数", -1)),
            _createElementVNode("span", _hoisted_43, _toDisplayString(bBaoFuData.value.totalAdd), 1)
          ]),
          _createElementVNode("div", _hoisted_44, [
            _cache[19] || (_cache[19] = _createElementVNode("span", { class: "stat-label" }, "自发展订购数", -1)),
            _createElementVNode("span", _hoisted_45, _toDisplayString(bBaoFuData.value.totalSef), 1)
          ]),
          _createElementVNode("div", _hoisted_46, [
            _cache[20] || (_cache[20] = _createElementVNode("span", { class: "stat-label" }, "总退订数", -1)),
            _createElementVNode("span", _hoisted_47, _toDisplayString(bBaoFuData.value.totalCal), 1)
          ]),
          _createElementVNode("div", _hoisted_48, [
            _cache[21] || (_cache[21] = _createElementVNode("span", { class: "stat-label" }, "总退订率", -1)),
            _createElementVNode("span", _hoisted_49, _toDisplayString(calculateRate(bBaoFuData.value.totalCal, bBaoFuData.value.totalAdd)) + "%", 1)
          ]),
          _createElementVNode("div", _hoisted_50, [
            _cache[22] || (_cache[22] = _createElementVNode("span", { class: "stat-label" }, "月订购数", -1)),
            _createElementVNode("span", _hoisted_51, _toDisplayString(bBaoFuData.value.monthAdd), 1)
          ]),
          _createElementVNode("div", _hoisted_52, [
            _cache[23] || (_cache[23] = _createElementVNode("span", { class: "stat-label" }, "自发展订购数", -1)),
            _createElementVNode("span", _hoisted_53, _toDisplayString(bBaoFuData.value.monthSef), 1)
          ]),
          _createElementVNode("div", _hoisted_54, [
            _cache[24] || (_cache[24] = _createElementVNode("span", { class: "stat-label" }, "月退订数", -1)),
            _createElementVNode("span", _hoisted_55, _toDisplayString(bBaoFuData.value.monthCal), 1)
          ]),
          _createElementVNode("div", _hoisted_56, [
            _cache[25] || (_cache[25] = _createElementVNode("span", { class: "stat-label" }, "月退订率", -1)),
            _createElementVNode("span", _hoisted_57, _toDisplayString(calculateRate(bBaoFuData.value.monthCal, bBaoFuData.value.monthAdd)) + "%", 1)
          ]),
          _createElementVNode("div", _hoisted_58, [
            _cache[26] || (_cache[26] = _createElementVNode("span", { class: "stat-label" }, "日订购数", -1)),
            _createElementVNode("span", _hoisted_59, _toDisplayString(bBaoFuData.value.dayAdd), 1)
          ]),
          _createElementVNode("div", _hoisted_60, [
            _cache[27] || (_cache[27] = _createElementVNode("span", { class: "stat-label" }, "自发展订购数", -1)),
            _createElementVNode("span", _hoisted_61, _toDisplayString(bBaoFuData.value.daySef), 1)
          ]),
          _createElementVNode("div", _hoisted_62, [
            _cache[28] || (_cache[28] = _createElementVNode("span", { class: "stat-label" }, "日退订数", -1)),
            _createElementVNode("span", _hoisted_63, _toDisplayString(bBaoFuData.value.dayCal), 1)
          ]),
          _createElementVNode("div", _hoisted_64, [
            _cache[29] || (_cache[29] = _createElementVNode("span", { class: "stat-label" }, "日退订率", -1)),
            _createElementVNode("span", _hoisted_65, _toDisplayString(calculateRate(bBaoFuData.value.dayCal, bBaoFuData.value.dayAdd)) + "%", 1)
          ])
        ]),
        (__props.hasDateFilter)
          ? (_openBlock(), _createElementBlock("div", _hoisted_66, [
              _cache[34] || (_cache[34] = _createElementVNode("div", { class: "summary-title" }, "查询汇总（按时间筛选）", -1)),
              _createElementVNode("div", _hoisted_67, [
                _createElementVNode("div", _hoisted_68, [
                  _cache[30] || (_cache[30] = _createElementVNode("span", { class: "summary-label" }, "订购数", -1)),
                  _createElementVNode("span", _hoisted_69, _toDisplayString(__props.summaryData.bBaoFuAdd), 1)
                ]),
                _createElementVNode("div", _hoisted_70, [
                  _cache[31] || (_cache[31] = _createElementVNode("span", { class: "summary-label" }, "自发展订购数", -1)),
                  _createElementVNode("span", _hoisted_71, _toDisplayString(__props.summaryData.bBaoFuSelf), 1)
                ]),
                _createElementVNode("div", _hoisted_72, [
                  _cache[32] || (_cache[32] = _createElementVNode("span", { class: "summary-label" }, "退订数", -1)),
                  _createElementVNode("span", _hoisted_73, _toDisplayString(__props.summaryData.bBaoFuCal), 1)
                ]),
                _createElementVNode("div", _hoisted_74, [
                  _cache[33] || (_cache[33] = _createElementVNode("span", { class: "summary-label" }, "退订率", -1)),
                  _createElementVNode("span", _hoisted_75, _toDisplayString(calculateRate(__props.summaryData.bBaoFuCal, __props.summaryData.bBaoFuAdd)) + "%", 1)
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_76, [
      _cache[53] || (_cache[53] = _createElementVNode("div", { class: "card-header" }, [
        _createElementVNode("span", { class: "card-title" }, "汇付数据")
      ], -1)),
      _createElementVNode("div", _hoisted_77, [
        _createElementVNode("div", _hoisted_78, [
          _createElementVNode("div", _hoisted_79, [
            _cache[36] || (_cache[36] = _createElementVNode("span", { class: "stat-label" }, "总订购数", -1)),
            _createElementVNode("span", _hoisted_80, _toDisplayString(huiFuData.value.totalAdd), 1)
          ]),
          _createElementVNode("div", _hoisted_81, [
            _cache[37] || (_cache[37] = _createElementVNode("span", { class: "stat-label" }, "自发展订购数", -1)),
            _createElementVNode("span", _hoisted_82, _toDisplayString(huiFuData.value.totalSef), 1)
          ]),
          _createElementVNode("div", _hoisted_83, [
            _cache[38] || (_cache[38] = _createElementVNode("span", { class: "stat-label" }, "总退订数", -1)),
            _createElementVNode("span", _hoisted_84, _toDisplayString(huiFuData.value.totalCal), 1)
          ]),
          _createElementVNode("div", _hoisted_85, [
            _cache[39] || (_cache[39] = _createElementVNode("span", { class: "stat-label" }, "总退订率", -1)),
            _createElementVNode("span", _hoisted_86, _toDisplayString(calculateRate(huiFuData.value.totalCal, huiFuData.value.totalAdd)) + "%", 1)
          ]),
          _createElementVNode("div", _hoisted_87, [
            _cache[40] || (_cache[40] = _createElementVNode("span", { class: "stat-label" }, "月订购数", -1)),
            _createElementVNode("span", _hoisted_88, _toDisplayString(huiFuData.value.monthAdd), 1)
          ]),
          _createElementVNode("div", _hoisted_89, [
            _cache[41] || (_cache[41] = _createElementVNode("span", { class: "stat-label" }, "自发展订购数", -1)),
            _createElementVNode("span", _hoisted_90, _toDisplayString(huiFuData.value.monthSef), 1)
          ]),
          _createElementVNode("div", _hoisted_91, [
            _cache[42] || (_cache[42] = _createElementVNode("span", { class: "stat-label" }, "月退订数", -1)),
            _createElementVNode("span", _hoisted_92, _toDisplayString(huiFuData.value.monthCal), 1)
          ]),
          _createElementVNode("div", _hoisted_93, [
            _cache[43] || (_cache[43] = _createElementVNode("span", { class: "stat-label" }, "月退订率", -1)),
            _createElementVNode("span", _hoisted_94, _toDisplayString(calculateRate(huiFuData.value.monthCal, huiFuData.value.monthAdd)) + "%", 1)
          ]),
          _createElementVNode("div", _hoisted_95, [
            _cache[44] || (_cache[44] = _createElementVNode("span", { class: "stat-label" }, "日订购数", -1)),
            _createElementVNode("span", _hoisted_96, _toDisplayString(huiFuData.value.dayAdd), 1)
          ]),
          _createElementVNode("div", _hoisted_97, [
            _cache[45] || (_cache[45] = _createElementVNode("span", { class: "stat-label" }, "自发展订购数", -1)),
            _createElementVNode("span", _hoisted_98, _toDisplayString(huiFuData.value.daySef), 1)
          ]),
          _createElementVNode("div", _hoisted_99, [
            _cache[46] || (_cache[46] = _createElementVNode("span", { class: "stat-label" }, "日退订数", -1)),
            _createElementVNode("span", _hoisted_100, _toDisplayString(huiFuData.value.dayCal), 1)
          ]),
          _createElementVNode("div", _hoisted_101, [
            _cache[47] || (_cache[47] = _createElementVNode("span", { class: "stat-label" }, "日退订率", -1)),
            _createElementVNode("span", _hoisted_102, _toDisplayString(calculateRate(huiFuData.value.dayCal, huiFuData.value.dayAdd)), 1)
          ])
        ]),
        (__props.hasDateFilter)
          ? (_openBlock(), _createElementBlock("div", _hoisted_103, [
              _cache[52] || (_cache[52] = _createElementVNode("div", { class: "summary-title" }, "查询汇总（按时间筛选）", -1)),
              _createElementVNode("div", _hoisted_104, [
                _createElementVNode("div", _hoisted_105, [
                  _cache[48] || (_cache[48] = _createElementVNode("span", { class: "summary-label" }, "订购数", -1)),
                  _createElementVNode("span", _hoisted_106, _toDisplayString(__props.summaryData.huiFuAdd), 1)
                ]),
                _createElementVNode("div", _hoisted_107, [
                  _cache[49] || (_cache[49] = _createElementVNode("span", { class: "summary-label" }, "自发展订购数", -1)),
                  _createElementVNode("span", _hoisted_108, _toDisplayString(__props.summaryData.huiFuSelf), 1)
                ]),
                _createElementVNode("div", _hoisted_109, [
                  _cache[50] || (_cache[50] = _createElementVNode("span", { class: "summary-label" }, "退订数", -1)),
                  _createElementVNode("span", _hoisted_110, _toDisplayString(__props.summaryData.huiFuCal), 1)
                ]),
                _createElementVNode("div", _hoisted_111, [
                  _cache[51] || (_cache[51] = _createElementVNode("span", { class: "summary-label" }, "退订率", -1)),
                  _createElementVNode("span", _hoisted_112, _toDisplayString(calculateRate(__props.summaryData.huiFuCal, __props.summaryData.huiFuAdd)) + "%", 1)
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})